import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { referralAPI } from '../lib/api';
import { Loader2 } from 'lucide-react';

export default function ReferralRedirectPage() {
  const { code, tourId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const trackAndRedirect = async () => {
      try {
        // Get source parameter (qr for QR code scans)
        const source = searchParams.get('source') || 'link';
        
        // Track the click with source
        await referralAPI.trackClick(code, tourId, source);
        
        // Store referral code in session for booking
        sessionStorage.setItem('referral_code', code);
        
        // Redirect to tour page
        navigate(`/tours/${tourId}`, { replace: true });
      } catch (error) {
        console.error('Error tracking referral:', error);
        // Still redirect even if tracking fails
        navigate(`/tours/${tourId}`, { replace: true });
      }
    };
    
    trackAndRedirect();
  }, [code, tourId, navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Redirecting to tour...</p>
      </div>
    </div>
  );
}
